/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://g4b7q43zlzdjdkainhfgu752yi.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-535xmufkwzg6xnlcc767jeixf4",
    "aws_cognito_identity_pool_id": "eu-central-1:05a0c305-65cf-4687-ad9b-b26402f49e29",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_eulzYh2y9",
    "aws_user_pools_web_client_id": "6vru2egn0v4r6atdr9acfdkkl9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "whispero211144-main",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
